import { useState } from "react";
import "@/App.css";
import { Instagram, Facebook, Mail, Phone, MapPin, ChevronDown, Camera, Heart, Star } from "lucide-react";

// Images from design guidelines
const heroImage = "https://images.unsplash.com/photo-1769635177236-116c95222fab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxhcnRpc3RpYyUyMHdlZGRpbmclMjBwaG90b2dyYXBoeSUyMGNvdXBsZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc3MDEyMjAwMnww&ixlib=rb-4.1.0&q=85";
const aboutImage = "https://images.unsplash.com/photo-1697718363306-a02488b41f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBwaG90b2dyYXBoZXIlMjBob2xkaW5nJTIwY2FtZXJhJTIwcG9ydHJhaXQlMjBibGFjayUyMGFuZCUyMHdoaXRlfGVufDB8fHx8MTc3MDEyMjAxMnww&ixlib=rb-4.1.0&q=85";

const portfolioImages = [
  { url: "https://images.unsplash.com/photo-1768445457199-ff363dc9f408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxhcnRpc3RpYyUyMHdlZGRpbmclMjBwaG90b2dyYXBoeSUyMGNvdXBsZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc3MDEyMjAwMnww&ixlib=rb-4.1.0&q=85", alt: "Esküvői pillanatok", category: "Esküvő" },
  { url: "https://images.unsplash.com/photo-1637449536946-22ba04e457a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBuYXR1cmUlMjBsYW5kc2NhcGUlMjBwaG90b2dyYXBoeSUyMG1vb2R5fGVufDB8fHx8MTc3MDEyMjAwN3ww&ixlib=rb-4.1.0&q=85", alt: "Hangulatos természet", category: "Természet" },
  { url: "https://images.unsplash.com/photo-1768445457231-3c042ea1e6ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxhcnRpc3RpYyUyMHdlZGRpbmclMjBwaG90b2dyYXBoeSUyMGNvdXBsZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc3MDEyMjAwMnww&ixlib=rb-4.1.0&q=85", alt: "Múzeumi pillanatok", category: "Portré" },
  { url: "https://images.unsplash.com/photo-1658568447944-c1a3db0ad6f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBuYXR1cmUlMjBsYW5kc2NhcGUlMjBwaG90b2dyYXBoeSUyMG1vb2R5fGVufDB8fHx8MTc3MDEyMjAwN3ww&ixlib=rb-4.1.0&q=85", alt: "Makró természet", category: "Természet" },
  { url: "https://images.unsplash.com/photo-1763391275169-d686f6d46f17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxhcnRpc3RpYyUyMHdlZGRpbmclMjBwaG90b2dyYXBoeSUyMGNvdXBsZSUyMHBvcnRyYWl0fGVufDB8fHx8MTc3MDEyMjAwMnww&ixlib=rb-4.1.0&q=85", alt: "Erkélyen a pár", category: "Esküvő" },
  { url: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800", alt: "Elegáns portré", category: "Portré" }
];

const testimonials = [
  { name: "Demo Ügyfél 1 (Referencia)", role: "Esküvői megrendelő", text: "Hihetetlen, ahogy megörökítette az esküvőnket! Minden pillanatot elkapott, amit fontosnak éreztünk. A képek gyönyörűek, időtlenek.", rating: 5 },
  { name: "Demo Ügyfél 2 (Referencia)", role: "Családi fotózás", text: "Profi hozzáállás, remek eredmények. A gyerekekkel is fantasztikusan bánt, így természetes képek születtek.", rating: 5 },
  { name: "Demo Ügyfél 3 (Referencia)", role: "Portré fotózás", text: "Életem legjobb portréfotói készültek el. Magabiztos lettem a képek láttán. Köszönöm a türelmet és a kreativitást!", rating: 5 }
];

function App() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Köszönjük az üzenetet! (Demo verzió - nincs valós küldés)");
  };

  return (
    <div className="min-h-screen bg-[#050505]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#050505]/80 backdrop-blur-md border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
          <button onClick={() => scrollToSection("hero")} className="font-montserrat text-sm uppercase tracking-[0.2em] text-[#F5F5F5] hover:text-teal-400 transition-colors" data-testid="nav-logo">
            BaraSuite (Referencia)
          </button>
          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection("about")} className="font-montserrat text-xs uppercase tracking-[0.15em] text-neutral-400 hover:text-teal-400 transition-colors" data-testid="nav-about">Rólam</button>
            <button onClick={() => scrollToSection("portfolio")} className="font-montserrat text-xs uppercase tracking-[0.15em] text-neutral-400 hover:text-teal-400 transition-colors" data-testid="nav-portfolio">Portfólió</button>
            <button onClick={() => scrollToSection("testimonials")} className="font-montserrat text-xs uppercase tracking-[0.15em] text-neutral-400 hover:text-teal-400 transition-colors" data-testid="nav-testimonials">Vélemények</button>
            <button onClick={() => scrollToSection("contact")} className="btn-primary text-xs" data-testid="nav-contact">Kapcsolat</button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="hero" className="hero-section" data-testid="hero-section">
        <img src={heroImage} alt="Művészi esküvői fotó - BaraSuite Photography" className="hero-image" />
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="font-montserrat text-xs uppercase tracking-[0.25em] text-teal-400 mb-6 opacity-0 animate-fade-in-up">Professzionális Fotográfia</span>
          <h1 className="font-montserrat text-4xl md:text-6xl lg:text-7xl font-light uppercase tracking-[0.15em] mb-6 opacity-0 animate-fade-in-up delay-100" data-testid="hero-title">BaraSuite</h1>
          <p className="font-montserrat text-lg md:text-xl font-light tracking-widest text-neutral-300 mb-4 opacity-0 animate-fade-in-up delay-200">/ Photography /</p>
          <p className="font-lato text-base md:text-lg text-neutral-400 mb-10 max-w-md opacity-0 animate-fade-in-up delay-300">Elkapjuk a pillanatot</p>
          <button onClick={() => scrollToSection("contact")} className="btn-primary opacity-0 animate-fade-in-up delay-400" data-testid="hero-cta">Kapcsolat</button>
          <button onClick={() => scrollToSection("about")} className="absolute bottom-10 left-1/2 -translate-x-1/2 text-neutral-500 hover:text-teal-400 transition-colors animate-bounce" data-testid="scroll-down" aria-label="Görgess le">
            <ChevronDown size={32} />
          </button>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="section bg-[#050505]" data-testid="about-section">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div className="relative">
              <img src={aboutImage} alt="BaraSuite fotós portré" className="w-full aspect-[3/4] object-cover grayscale hover:grayscale-0 transition-all duration-700" />
              <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-teal-400/30 hidden lg:block"></div>
            </div>
            <div>
              <span className="font-montserrat text-xs uppercase tracking-[0.25em] text-teal-400 mb-4 block">Bemutatkozás</span>
              <h2 className="font-montserrat text-3xl md:text-4xl font-light uppercase tracking-widest mb-8" data-testid="about-title">Rólam</h2>
              <p className="font-lato text-base md:text-lg text-neutral-400 leading-relaxed mb-6">Több mint 10 éve foglalkozom professzionális fotográfiával. Számomra minden pillanat egyedi és megismételhetetlen - ezért is törekszem arra, hogy a lehető legtermészetesebb módon örökítsem meg az emlékeidet.</p>
              <p className="font-lato text-base md:text-lg text-neutral-400 leading-relaxed mb-8">Legyen szó esküvőről, családi eseményről, portréfotózásról vagy kreatív projektről, célom mindig ugyanaz: olyan képeket készíteni, amelyek évtizedek múlva is ugyanazt az érzést idézik fel benned.</p>
              <div className="flex flex-wrap gap-8">
                <div className="text-center">
                  <Camera className="w-8 h-8 text-teal-400 mx-auto mb-2" />
                  <span className="font-montserrat text-2xl font-light text-[#F5F5F5]">500+</span>
                  <p className="font-montserrat text-xs uppercase tracking-wider text-neutral-500 mt-1">Projekt</p>
                </div>
                <div className="text-center">
                  <Heart className="w-8 h-8 text-teal-400 mx-auto mb-2" />
                  <span className="font-montserrat text-2xl font-light text-[#F5F5F5]">10+</span>
                  <p className="font-montserrat text-xs uppercase tracking-wider text-neutral-500 mt-1">Év Tapasztalat</p>
                </div>
                <div className="text-center">
                  <Star className="w-8 h-8 text-teal-400 mx-auto mb-2" />
                  <span className="font-montserrat text-2xl font-light text-[#F5F5F5]">100%</span>
                  <p className="font-montserrat text-xs uppercase tracking-wider text-neutral-500 mt-1">Elégedettség</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      <section id="portfolio" className="section bg-[#0a0a0a]" data-testid="portfolio-section">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="font-montserrat text-xs uppercase tracking-[0.25em] text-teal-400 mb-4 block">Munkáim</span>
            <h2 className="font-montserrat text-3xl md:text-4xl font-light uppercase tracking-widest" data-testid="portfolio-title">Portfólió</h2>
          </div>
          <div className="masonry">
            {portfolioImages.map((image, index) => (
              <div key={index} className="masonry-item gallery-item group cursor-pointer" data-testid={`gallery-item-${index}`}>
                <img src={image.url} alt={image.alt} className="w-full object-cover" style={{ aspectRatio: index % 3 === 0 ? "3/4" : index % 3 === 1 ? "4/3" : "1/1" }} />
                <div className="gallery-caption">
                  <span className="font-montserrat text-xs uppercase tracking-[0.15em] text-teal-400">{image.category}</span>
                  <p className="font-lato text-sm text-neutral-300 mt-1">{image.alt}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="section bg-[#050505]" data-testid="testimonials-section">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="font-montserrat text-xs uppercase tracking-[0.25em] text-teal-400 mb-4 block">Mit mondanak rólam</span>
            <h2 className="font-montserrat text-3xl md:text-4xl font-light uppercase tracking-widest" data-testid="testimonials-title">Ügyfélvélemények</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card p-8" data-testid={`testimonial-${index}`}>
                <div className="flex gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="w-4 h-4 fill-teal-400 text-teal-400" />
                  ))}
                </div>
                <p className="font-lato text-neutral-400 leading-relaxed mb-6 italic">"{testimonial.text}"</p>
                <div>
                  <p className="font-montserrat text-sm uppercase tracking-wider text-[#F5F5F5]">{testimonial.name}</p>
                  <p className="font-lato text-xs text-neutral-500 mt-1">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="section bg-[#0a0a0a]" data-testid="contact-section">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <span className="font-montserrat text-xs uppercase tracking-[0.25em] text-teal-400 mb-4 block">Lépj kapcsolatba</span>
              <h2 className="font-montserrat text-3xl md:text-4xl font-light uppercase tracking-widest mb-8" data-testid="contact-title">Kapcsolat</h2>
              <p className="font-lato text-neutral-400 leading-relaxed mb-10">Kérdésed van, vagy szeretnél időpontot egyeztetni? Írj nekem bátran! Általában 24 órán belül válaszolok.</p>
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 border border-white/10 flex items-center justify-center">
                    <Mail className="w-5 h-5 text-teal-400" />
                  </div>
                  <div>
                    <p className="font-montserrat text-xs uppercase tracking-wider text-neutral-500">Email</p>
                    <p className="font-lato text-[#F5F5F5]">hello@barasuite.hu</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 border border-white/10 flex items-center justify-center">
                    <Phone className="w-5 h-5 text-teal-400" />
                  </div>
                  <div>
                    <p className="font-montserrat text-xs uppercase tracking-wider text-neutral-500">Telefon</p>
                    <p className="font-lato text-[#F5F5F5]">+36 30 123 4567</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 border border-white/10 flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-teal-400" />
                  </div>
                  <div>
                    <p className="font-montserrat text-xs uppercase tracking-wider text-neutral-500">Helyszín</p>
                    <p className="font-lato text-[#F5F5F5]">Budapest, Magyarország</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <form onSubmit={handleSubmit} className="space-y-8" data-testid="contact-form">
                <div>
                  <input type="text" placeholder="Név" className="contact-input" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} data-testid="contact-name" />
                </div>
                <div>
                  <input type="email" placeholder="Email cím" className="contact-input" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} data-testid="contact-email" />
                </div>
                <div>
                  <textarea placeholder="Üzenet" rows={5} className="contact-input resize-none" value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} data-testid="contact-message" />
                </div>
                <button type="submit" className="btn-primary w-full" data-testid="contact-submit">Üzenet küldése</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-6 bg-[#050505] border-t border-white/5" data-testid="footer-section">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-8">
            <div className="text-center md:text-left">
              <p className="font-montserrat text-sm uppercase tracking-[0.2em] text-[#F5F5F5] mb-2">BaraSuite Photography (Referencia)</p>
              <p className="font-lato text-sm text-neutral-500">© 2024 Demo oldal - Fejlesztés: <a href="https://barasuite.hu" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-teal-300 transition-colors">BaraSuite</a></p>
            </div>
            <div className="flex gap-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" data-testid="social-instagram" aria-label="Instagram">
                <Instagram size={18} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" data-testid="social-facebook" aria-label="Facebook">
                <Facebook size={18} />
              </a>
              <a href="mailto:hello@barasuite.hu" className="social-icon" data-testid="social-email" aria-label="Email">
                <Mail size={18} />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
